import type { LevelType } from '@/domain/model/measures'

export const transformLevelsToCategories = (levels?: LevelType[]) => {
  if (!levels || !levels.length) return undefined

  const sortedLevels = [...levels].sort((a, b) => a.threshold - b.threshold)

  return (score: number) => {
    for (let i = 0; i < sortedLevels.length; i++) {
      const current = sortedLevels[i]
      const next = sortedLevels[i + 1]

      if (!next || score < next.threshold) {
        return {
          label: current.label,
          threshold: current.threshold,
          color: current.color,
        }
      }
    }

    return { label: 'Unknown', threshold: 0, color: '' }
  }
}

export type LevelCategoryModel = ReturnType<
  NonNullable<ReturnType<typeof transformLevelsToCategories>>
>
